import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { SpinnerService } from '../../core/service/spinner.service';
import { BROADCAST_CHANNEL_NAME } from '../../core/component/sidenav/side-nav.component';
import { SpinnerType } from '../common/spinner-types';

export const IS_SPINNER_ACTIVE = new HttpContextToken<boolean>(() => false);
export const SPINNER_TEXT = new HttpContextToken<string>(() => '');
export const SPINNER_TYPE = new HttpContextToken<SpinnerType>(() => SpinnerType.DEFAULT);

@Injectable({ providedIn: 'root' })
export class LoadInterceptor {
  private spinner = inject(SpinnerService);
  broadcaster = new BroadcastChannel(BROADCAST_CHANNEL_NAME);

  intercept(
    request: HttpRequest<any>,
    next: (req: HttpRequest<any>) => Observable<HttpEvent<any>>
  ): Observable<HttpEvent<any>> {
    const isSpinnerActive = request.context.get(IS_SPINNER_ACTIVE);
    const spinnerText = request.context.get(SPINNER_TEXT);
    const spinnerType = request.context.get(SPINNER_TYPE);

    if (isSpinnerActive) {
      this.spinner.addActiveRequest(spinnerText, spinnerType);
    }
    return this.handler(next, request, isSpinnerActive ? spinnerType : undefined);
  }

  /**
   * Sends the signal to all fms tabs, that they need to reset their logout counter.
   * After the response is handled, decrements the active spinner request counter.
   *
   * @param next is the stream of request events.
   * @param request is http request per se.
   * @param spinnerType is the type of spinner to remove when request completes.
   */
  handler(next: (req: HttpRequest<any>) => Observable<HttpEvent<any>>, request: HttpRequest<any>, spinnerType?: SpinnerType): Observable<HttpEvent<any>> {
    return next(request).pipe(
      map((event: HttpEvent<any>) => {
        // update the logout counter
        if (event instanceof HttpResponse && !event.url.includes('logout')) {
          this.broadcaster.postMessage('Oida schon wieder die GIS.');
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => throwError(error)),
      finalize(() => {
        this.spinner.removeActiveRequest(spinnerType);
      }),
    );
  }
}
